export default "__VITE_PUBLIC_ASSET__1af03099__"